import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import "./RecentJobs.css";

const RecentJobs = ({ jobs, setActiveMain }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const jobID = new URLSearchParams(location.search).get("jobID");
  const companyID = new URLSearchParams(location.search).get("companyID");

  const handleApplicantClick = (jobId) => {
    navigate(`/all-candidates?companyID=${encodeURIComponent(companyID)}&jobID=${encodeURIComponent(jobId)}`);
  };

  return (
    <div className="comp-recent-jobs-container">
      {/* Header Section */}
      <div className="comp-recent-jobs-header">
        <h2 className="comp-recent-jobs-title">Recent Job</h2>
        <button
          className="comp-view-all-jobs-btn"
          onClick={() => navigate(`/all-jobs?companyID=${encodeURIComponent(companyID)}`, {
            state: { companyID: companyID, companyName: location.state?.companyName, email: location.state?.email }
          })}
        >
          View All Jobs
        </button>
      </div>

      {/* Divider */}
      <div className="comp-recent-jobs-divider"></div>

      {/* Job List Section */}
      <div className="comp-jobs-list-container">
        <h3 className="comp-published-jobs-title">Jobs Published ({jobs.length})</h3>
        <div className="comp-jobs-list">
          {jobs.slice(0, 4).map((job) => (
            <div key={job.job_id} className="comp-job-item" onClick={() => handleApplicantClick(job.job_id)}>
              <div className="comp-job-info">
                <h4 className="comp-job-title">{job.job_title}</h4>
                <span className="comp-job-location">{job.experience_range} - {job.location}</span>
              </div>
              <div className="comp-job-stats">
                <span>{job.applicants} Views</span>
                <span>{job.applicants} Applied</span>
                <div className="comp-recommended-candidates">
                  <span>{job.applicants} Recommended Candidates</span>
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/db6943e03c9ead232161ca74aef4d4a77ba570a616c794c2747ce8d1e485c0e4"
                    alt="Recommended Icon"
                    className="comp-recommended-icon"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentJobs;
